import {BaseDomainModel} from "../../../infrastructure/models/base-domain-model";
import {LineupsMemberDomainModel} from "./lineups-member/lineups-member-domain-model";
import {LineupsApiModel} from "./lineups-api-model";
import {PlayersStatisticsDomainModel} from "./players-statistics/players-statistics.domain-model";
import {StatsCategoryDomainModel} from "./statsCategory/stats-category.domain-model";
import {StatsCategoryApiModel} from "./statsCategory/stats-category.api-model";

export class LineupsDomainModel extends BaseDomainModel {
  apiModel: LineupsApiModel;
  members: Array<LineupsMemberDomainModel> = [];
  key: String;

  constructor(apiModel: LineupsApiModel = {}, members: Array<LineupsMemberDomainModel> = [], key: String ="") {
    super(apiModel);

    this.key = key;
    this.members.push(...members);
  }

  get status(): String {
    return this.apiModel.status;
  }

  get formation(): String {
    return this.apiModel.formation;
  }

  get hasFieldPositions(): Boolean {
    return this.apiModel.hasFieldPositions;
  }

  get playersStatistics(): PlayersStatisticsDomainModel {
    let playersStatistics: PlayersStatisticsDomainModel = null;

    if(this.apiModel.playersStatistics) {
      playersStatistics = new PlayersStatisticsDomainModel(this.apiModel.playersStatistics, this.members);
    }

    return playersStatistics;
  }

  get statsCategory(): Array<StatsCategoryDomainModel> {
    const statsCategory: Array<StatsCategoryDomainModel> = this.apiModel.statsCategory?.map((statsCategory: StatsCategoryApiModel) => new StatsCategoryDomainModel(statsCategory));

    return statsCategory;
  }

  get isProbable(): String {
    return this.apiModel.isProbable;
  }
}